var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.errors.slice(0,3)),function(error,index){return _c('b-alert',{key:index,attrs:{"variant":"danger","show":""}},[_vm._v("\n        "+_vm._s(error)+"\n    ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }